import { ArrowBackIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import ForgetPassword from "../components/modals/ForgetPassword";
import { GeneralContext } from "../context/GeneralContext";
import EncryptToken from "../utils/secure/EncryptToken";

//image
import BUP from "../assets/logo/bup-wakil.png";
import BgLogin from "../assets/background/login.png";
import Pemda from "../assets/logo/pemda-karangasem.png";
import BPD from "../assets/logo/bank-bpd.png";
import Ipos from "../assets/logo/ipos.png";

export default function Login() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const url = "/auth";
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const { setUID, UID } = useContext(GeneralContext);

  const [openForgePassword, setOpenForgePassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorResponse, setErrorResponse] = useState();
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };
  const handleCloseForgetPassword = () => {
    setOpenForgePassword(false);
  };
  const handleOpenForgetPassword = () => {
    setOpenForgePassword(true);
  };

  const handleLogin = () => {
    axios
      .post(baseURL + url, loginData)
      .then((res) => {
        if (res.status === 200) {
          const result = res.data.data;
          console.log(res.data.data);
          localStorage.setItem("username", result.username);
          localStorage.setItem("multi_product", result.multi_product ? 1 : 0);
          localStorage.setItem("access_token", result.access_token);
          localStorage.setItem(
            "refresh_token",
            EncryptToken(result.refresh_token)
          );
          window.location.replace("/");
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setErrorResponse("Username atau Password Salah");
        }
        if (error.response.status === 403) {
          setErrorResponse(
            "Role ini tidak bisa login, mohon hubungi administator"
          );
        }
      });
  };
  return (
    <Box
      bg={!mobile && `url(${BgLogin}) no-repeat center center fixed`}
      minHeight="100vh"
      maxWidth="100vw"
      bgSize="cover"
      px={mobile ? "0" : "25%"}
    >
      <HStack hidden={mobile} justifyContent="space-between" py="8">
        <img src={Pemda} alt="Logo Pemda Karangasem" width="80px" />
        <img src={BPD} alt="Logo Pemda Karangasem" width="100px" />
        <img src={Ipos} alt="Logo Pemda Karangasem" width="190px" />
        <img src={BUP} alt="Logo Pemda Karangasem" width="100px" />
      </HStack>
      <Box hidden={!mobile}>
        <Button variant="ghost" onClick={() => window.history.back()}>
          <ArrowBackIcon mr="2" /> Masuk
        </Button>
      </Box>
      <Box p="10%" bgColor="white" borderRadius={mobile ? "0" : "10px"}>
        <Text fontWeight="500" fontSize="25px">
          Selamat Datang di MBLB Karangasem
        </Text>
        <Text fontWeight="400" color="#B9B9B9">
          Silahkan memasukkan username dan password terlebih dahulu
        </Text>
        <FormControl pt="5">
          <FormLabel>Username</FormLabel>
          <Input
            type="text"
            name="username"
            value={loginData.username}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl pt="5">
          <FormLabel>Password</FormLabel>
          <InputGroup>
            <Input
              type={showPassword ? "text" : "password"}
              name="password"
              value={loginData.password}
              onChange={handleChange}
            />
            <InputRightElement
              children={
                <IconButton
                  bgColor="transparent"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                </IconButton>
              }
            />
          </InputGroup>
        </FormControl>
        {errorResponse && (
          <Text textAlign="center" color="red" py="3">
            {errorResponse}{" "}
          </Text>
        )}
        <Box display="flex" justifyContent="flex-end" my="2">
          <Button onClick={handleOpenForgetPassword} variant="ghost">
            Lupa Password?
          </Button>
        </Box>
        <Button
          my="3"
          disabled={loginData.username === "" && loginData.password === ""}
          width="full"
          variant="outline"
          colorScheme="blue"
          p="8"
          onClick={handleLogin}
        >
          Masuk
        </Button>
      </Box>
      <ForgetPassword
        isOpen={openForgePassword}
        onClose={handleCloseForgetPassword}
      />
    </Box>
  );
}
